<template>
  <div class="section usage">
    <div class="content">
      <div>
        {{ $t("Home.oneday_day") }}
        <input type="date" id="start" v-model="dateFrom" :max="today()" />
      </div>

      <!-- ラジオボタン -->
      <div class="mt-3">
        <div>
          <input type="radio" id="last_price" name="last_price" value="last_price" v-model="method_type" />
          <label for="last_price">{{ $t("Home.oneday_last_price") }}</label>
        </div>
        <div class="mt-1">
          <input type="radio" id="fifo" name="fifo" value="fifo" v-model="method_type" />
          <label for="fifo">{{ $t("Home.oneday_fifo") }}</label>
        </div>
        <div class="mt-1">
          <input type="radio" id="moving_average" name="moving_average" value="moving_average" v-model="method_type" />
          <label for="moving_average">{{ $t("Home.oneday_moving_average_method") }}</label>
        </div>
      </div>

      <!-- 入出庫がない履歴データを除外する -->
      <div class="mt-3">
        <div>
          <input type="checkbox" id="only_purchase_and_packing_slip" v-model="is_only_purchase_and_packing_slip" />
          <label for="only_purchase_and_packing_slip">{{ $t("Home.only_purchase_and_packing_slip") }}</label>
        </div>
      </div>

      <!-- 入庫データの仕入単価がない場合は在庫データの仕入単価で計算する -->
      <div class="mt-1">
        <div>
          <input type="checkbox" id="is_use_inventory_unit_price" v-model="is_use_inventory_unit_price" />
          <label for="is_use_inventory_unit_price">{{ $t("Home.is_use_inventory_unit_price") }}</label>
        <span
            style="
              color: white;
              background-color: #e07800;
              margin-left: 0.5rem;
              padding: 0.1em 0.4em;
              border-radius: 4px;
              font-size: 0.9rem;
            "
            >New</span
          >
        </div>
      </div>

      <!-- ラジオボタン -->
      <div v-if="method_type == 'moving_average' "class="mt-3">
        <div>{{ $t('Home.sort_type_option') }}</div>
        <div class="mt-1">
          <input type="radio" id="purchase_first" name="purchase_first" value="purchase_first" v-model="sort_type" />
          <label for="purchase_first">{{ $t('Home.purchase_first') }}</label>
        </div>
        <div class="mt-1">
          <input type="radio" id="delivery_first" name="delivery_first" value="delivery_first" v-model="sort_type" />
          <label for="delivery_first">{{ $t('Home.delivery_first') }}</label>
        </div>
      </div>

      <div v-if="method_type == 'moving_average' && !is_advanced_plan">
        <div class="alert alert-warning mt-3" role="alert">
          <div>{{ $t("Home.advanced_plan_warning_detail_1") }}</div>
          <div>{{ $t("Home.advanced_plan_warning_detail_2") }}</div>
        </div>
      </div>

      <div v-if="isLoading" class="mt-4">
        <button class="btn btn-primary" type="button" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Loading...</span>
        </button>

        &nbsp;
        <button class="btn btn-light" type="button" @click="cancel()">
          <span>Cancel</span>
        </button>
        <div class="content_note">
          <div>※{{ $t("Home.aLotOfInventory") }}</div>
          <div>※{{ $t("Home.inBackground") }}</div>
        </div>
      </div>
      <div v-else class="mt-4">
        <button class="btn btn-primary" @click="aggregateBtnClicked()">{{ $t("Home.tally") }}</button>
      </div>

      <!-- ヘルプページ -->
      <div class="mt-3">
        <div v-if="selectedLanguage == 'ja'">
          {{ $t("Home.help_ja_1") }}
          <a href="https://support.zaico.co.jp/hc/ja/articles/5212791543321" target="_blank">
            {{ $t("Home.help_ja_2") }}
          </a>
          {{ $t("Home.help_ja_3") }}
        </div>
        <div v-else>
          {{ $t("Home.help_en_1") }}
          <a href="https://support.zaico.co.jp/hc/ja/articles/5212791543321" target="_blank">
            {{ $t("Home.help_en_2") }}
          </a>
        </div>
      </div>

      <div v-if="isShowError">
        <br />
        <div class="alert alert-danger" role="alert">
          <span>
            {{ errorMsg }}
            &nbsp;
            <a href="https://www.zaico.co.jp/smart-zaico/help/contact/" target="_blank">HELP</a>
          </span>
        </div>
      </div>

      <!-- 進捗バー -->
      <br />
      <div v-if="isLoading" class="progress">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          :aria-valuenow="progressPercent"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="{ width: progressPercentStr }"
        >
          {{ progressPercentStr }}
        </div>
      </div>

      <!-- 集計完了 -->
      <div v-if="isCompletedCreateZaicoMoneyList">
        <!-- サマリーテーブル -->
        <table class="summary-table" style="width: 100%">
          <tbody>
            <tr>
              <td style="width: 30%; background-color: white;"></td>
              <td style="width: 35%; border-top-left-radius: 20px;">{{ $t("Home.amount") }}</td>
              <td style="width: 35%; border-top-right-radius: 20px;">{{ $t("Home.totalQuantity") }}</td>
            </tr>
            <tr>
              <td style="border-top-left-radius: 20px; border-bottom-left-radius: 20px;">{{ $t("Home.asOfSpecifiedDate", { date: dateOfSummary.replace(/-/g, "/") }) }}</td>
              <td><span class="value">{{ totalAmountDateFrom.toLocaleString(undefined, { maximumFractionDigits: 4 }) }}</span></td>
              <td style="border-bottom-right-radius: 20px">
                <span class="value">{{ totalQuantityDateFrom.toLocaleString(undefined, { maximumFractionDigits: 4 }) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 詳細データ -->
        <div style="margin-top: 1rem; border: darkgray 1px solid; padding: 1rem">
          <div v-if="method_type == 'fifo'" class="fs-3 fw-bold">
            {{ $t("Home.detailed_data") }}
          </div>
          <div style="margin-left: 2rem">
            <div>{{ $t("Home.totalNumber") }}：{{ zaicoMoneyList.length.toLocaleString() }}</div>
            <!-- ボタン -->
            <div class="mt-3">
              <div class="button-container">
                <div v-if="isShowPreview">
                  <button class="btn btn-info" @click="closePreview()">{{ $t("Home.closeTallyResults") }}</button>
                </div>
                <div v-else>
                  <button class="btn btn-info" :disabled="zaicoMoneyList.length === 0" @click="openPreview()">{{ $t("Home.viewTallyResults") }}</button>
                </div>
                <button
                  class="btn btn-primary"
                  :disabled="method_type == 'moving_average' && !is_advanced_plan"
                  @click="downloadCSV(zaicoMoneyList, column_names, 'OneDay_downloadCSV')"
                >
                  {{ $t("Home.CSVDownload") }}
                </button>
              </div>
            </div>
            <!-- プレビュー -->
            <div v-if="isShowPreview" class="mt-3">
              <!-- プレビューデータ -->
              <div v-if="zaicoMoneyList.length > 1000">・{{ $t("Home.upTo1000") }}</div>
              <vue-good-table
                :columns="columns"
                :rows="zaicoMoneyList.slice(0, maxPreviewRows)"
                max-height="500px"
                :fixed-header="false"
                :row-style-class="rowStyleClassFn"
                @on-row-click="onRowClick"
                :pagination-options="{
                  enabled: false,
                  mode: 'records',
                  perPage: 100,
                  position: 'top',
                  perPageDropdown: [10, 50, 100],
                  nextLabel: '次のページ',
                  prevLabel: '前のページ',
                  rowsPerPageLabel: '１ページ当たりの件数',
                  infoFn: (params) => `合計：${params.totalRecords}件　現在： ${params.currentPage}ページ目`,
                }"
              />
              <!-- プレビュー警告 -->
              <div v-if="hasNoPriceData">
                <div class="alert alert-warning mt-2" role="alert">
                  <strong class="fs-3">{{ $t("Home.hasNoPriceData1") }}</strong>
                  <div>{{ $t("Home.hasNoPriceData2") }}</div>
                  <div>{{ $t("Home.hasNoPriceData6") }}</div>
                  <div>{{ $t("Home.hasNoPriceData3") }}</div>
                  <ul>
                    <li>{{ $t("Home.hasNoPriceData4") }}</li>
                    <li>{{ $t("Home.hasNoPriceData5") }}</li>
                    <li>{{ $t("Home.hasNoPriceData7") }}</li>
                  </ul>
                </div>
              </div>
              <!-- グラフ -->
              <div class="mt-4" v-if="chartDataByCustomer.labels.length > 0">
                <BaseBarChart :chartData="chartDataByCustomer" />
              </div>
              <div class="mt-4" v-if="chartData.labels.length > 0">
                <BaseBarChart :chartData="chartData" />
              </div>
            </div>
          </div>
        </div>

        <!-- 集計データ -->
        <div v-if="method_type == 'fifo'" style="margin-top: 2rem; border: darkgray 1px solid; padding: 1rem">
          <div class="fs-3 fw-bold">
            {{ $t("Home.aggregate_data") }}
          </div>
          <div style="margin-left: 2rem">
            <div>{{ $t("Home.totalNumber") }}：{{ zaicoMoneyAggregatedList.length.toLocaleString() }}</div>
            <!-- ボタン -->
            <div class="mt-3">
              <div v-if="!is_advanced_plan">
                <div class="alert alert-warning mt-3" role="alert">
                  <div>{{ $t("Home.advanced_plan_warning_detail_1") }}</div>
                  <div>{{ $t("Home.advanced_plan_warning_detail_2") }}</div>
                </div>
              </div>
              <div class="button-container">
                <div v-if="isShowAggregatedPreview">
                  <button class="btn btn-info" @click="closeAggregatedPreview()">
                    {{ $t("Home.closeTallyResults") }}
                  </button>
                </div>
                <div v-else>
                  <button class="btn btn-info" @click="openAggregatedPreview()">
                    {{ $t("Home.viewTallyResults") }}
                  </button>
                </div>
                <button
                  class="btn btn-primary"
                  :disabled="!is_advanced_plan"
                  @click="downloadCSV(zaicoMoneyAggregatedList, column_names, 'OneDay_downloadAggregatedCSV')"
                >
                  {{ $t("Home.CSVDownload") }}
                </button>
              </div>
            </div>
            <!-- プレビュー -->
            <div v-if="isShowAggregatedPreview" class="mt-3">
              <!-- プレビューデータ -->
              <div v-if="is_advanced_plan && zaicoMoneyAggregatedList.length > 1000">・{{ $t("Home.upTo1000") }}</div>
              <vue-good-table
                :columns="columns"
                :rows="zaicoMoneyAggregatedList.slice(0, maxPreviewRowsAggregatedList)"
                max-height="500px"
                :fixed-header="false"
                :row-style-class="rowStyleClassFn"
                @on-row-click="onRowClick"
                :pagination-options="{
                  enabled: false,
                  mode: 'records',
                  perPage: 100,
                  position: 'top',
                  perPageDropdown: [10, 50, 100],
                  nextLabel: '次のページ',
                  prevLabel: '前のページ',
                  rowsPerPageLabel: '１ページ当たりの件数',
                  infoFn: (params) => `合計：${params.totalRecords}件　現在： ${params.currentPage}ページ目`,
                }"
              />
              <!-- プレビュー警告 -->
              <div v-if="hasNoPriceData">
                <div class="alert alert-warning mt-2" role="alert">
                  <strong class="fs-3">{{ $t("Home.hasNoPriceData1") }}</strong>
                  <div>{{ $t("Home.hasNoPriceData2") }}</div>
                  <div>{{ $t("Home.hasNoPriceData6") }}</div>
                  <div>{{ $t("Home.hasNoPriceData3") }}</div>
                  <ul>
                    <li>{{ $t("Home.hasNoPriceData4") }}</li>
                    <li>{{ $t("Home.hasNoPriceData5") }}</li>
                    <li>{{ $t("Home.hasNoPriceData7") }}</li>
                  </ul>
                </div>
              </div>
              <!-- グラフ -->
              <div class="mt-4" v-if="chartDataByCustomer.labels.length > 0">
                <BaseBarChart :chartData="chartDataByCustomer" />
              </div>
              <div class="mt-4" v-if="chartData.labels.length > 0">
                <BaseBarChart :chartData="chartData" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- isCompletedFetchAllを監視させるためのダミーエレメント -->
  <div style="display: none">{{ isCompletedFetchAll }}</div>
</template>

<script>
// API実行
import axios from "axios";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// table
import VueGoodTable from "./../components/vue3-good-table-main/Table";
// 共通メソッド
import useCommonMethods from "./../useCommonMethods.js";
// グラフ
import BaseBarChart from "./../components/BaseBarChart.vue";

export default {
  name: "TowDays",
  components: {
    Loading,
    VueGoodTable,
    BaseBarChart,
  },
  props: ["selectedLanguage", "is_advanced_plan", "maxPreviewRowsAggregatedList"],
  data() {
    return {
      NODE_ENV: process.env.NODE_ENV,
      dateFrom: this.endOfLastMonth(),
      dateOfSummary: "",
      method_type: "last_price",
      sort_type: "delivery_first",
      zaicoMoneyList: [],
      zaicoMoneyAggregatedList: [],
      inventories: [], // APIから取得した在庫一覧
      current_inventories: [], // APIから取得した在庫一覧
      all_histories: [],
      histories_plus: [],
      histories_minus: [],
      histories_canceled: {},
      purchases: {}, // APIから取得した入庫一覧。key:入庫ID value:[customer_name]
      purchase_items: {}, // dateFromまでの入庫明細一覧。key:入庫ID_在庫ID value:[quantity, unit_price]
      deliveries: {}, // dateFromまでの出庫明細一覧。key:出庫ID_在庫ID value:[quantity]
      isCompletedFetchPastInventories: false,
      isCompletedFetchCurrentInventories: false,
      isCompletedFetchAllHistories: false,
      isCompletedFetchPurchases: false,
      isCompletedFetchPurchasesItems: false,
      isCompletedFetchDeliveries: false,
      isCompletedCreateZaicoMoneyList: false,
      isLoading: false,
      isShowError: false,
      isShowPreview: false,
      isShowAggregatedPreview: false,
      errorMsg: "",
      columns: [],
      column_names: [],
      progress: 0,
      progressPercentStr: "",
      hasNoPriceData: false,
      totalAmountDateFrom: 0,
      totalQuantityDateFrom: 0,
      aggregatedTotalAmountDateFrom: 0,
      userId: "",
      chartData: {
        titleText: "",
        labels: [],
        datasets: [
          {
            label: "在庫金額",
            data: [],
          },
        ],
      },
      chartDataByCustomer: {
        titleText: "",
        labels: [],
        datasets: [
          {
            label: "在庫金額",
            data: [],
          },
        ],
      },
      only_purchase_and_packing_slip: false,
      is_use_inventory_unit_price: false,
      calc_errors: {},
    };
  },
  created() {
    const method_type = localStorage.getItem("method_type");
    if (method_type) {
      this.method_type = method_type;
    } else {
      this.method_type = "last_price";
    }
    const is_only_purchase_and_packing_slip = localStorage.getItem("is_only_purchase_and_packing_slip");
    if (is_only_purchase_and_packing_slip == 'true') {
      this.is_only_purchase_and_packing_slip = true;
    } else {
      this.is_only_purchase_and_packing_slip = false;
    }
    const is_use_inventory_unit_price = localStorage.getItem("is_use_inventory_unit_price");
    if (is_use_inventory_unit_price == 'true') {
      this.is_use_inventory_unit_price = true;
    } else {
      this.is_use_inventory_unit_price = false;
    }
    const sort_type = localStorage.getItem("sort_type");
    if (sort_type == 'purchase_first' || sort_type == 'delivery_first') {
      this.sort_type = sort_type
    } else {
      this.sort_type = 'delivery_first';
    }
  },
  computed: {
    accessToken: function () {
      return this.$store.state.accessToken;
    },
    /**
     * プログレスバー
     */
    progressPercent: function () {
      let progressPercent = 0;
      progressPercent = this.progress * 100;
      progressPercent = Math.round(progressPercent);
      this.progressPercentStr = progressPercent + "%";
      return progressPercent;
    },
    /**
     * データが揃ったら在庫金額の計算を開始する
     */
    isCompletedFetchAll: function () {
      const isCompletedFetchAll =
        this.isCompletedFetchPastInventories &&
        this.isCompletedFetchCurrentInventories &&
        this.isCompletedFetchAllHistories &&
        this.isCompletedFetchPurchases &&
        this.isCompletedFetchPurchasesItems &&
        this.isCompletedFetchDeliveries;
      if (isCompletedFetchAll && this.isLoading && !this.isShowError) {
        console.log("[init] this.inventories: ");
        console.log(JSON.parse(JSON.stringify(this.inventories)));
        console.log("[init] this.current_inventories: ");
        console.log(JSON.parse(JSON.stringify(this.current_inventories)));

        this.inventories = this.merge_current_inventories(this.inventories, this.current_inventories);
        console.log("[merge_current_inventories] this.inventories: ");
        console.log(JSON.parse(JSON.stringify(this.inventories)));

        const history_operation_datetime_for_purchase_items = this.create_operation_datetime_for_purchase_items(
          this.all_histories
        );
        console.log("[create_operation_datetime_for_purchase_items] history_operation_datetime_for_purchase_items: ");
        console.log(JSON.parse(JSON.stringify(history_operation_datetime_for_purchase_items)));

        this.inventories = this.calc_quantity_by_past_purchase_date(
          this.inventories,
          this.purchase_items,
          this.dateFrom,
          history_operation_datetime_for_purchase_items,
          this.calc_errors
        );
        console.log("[calc_quantity_by_past_purchase_date] this.inventories: ");
        console.log(JSON.parse(JSON.stringify(this.inventories)));

        const history_operation_datetime_for_deliveries = this.create_operation_datetime_for_deliveries(
          this.all_histories
        );
        console.log("[create_operation_datetime_for_deliveries] history_operation_datetime_for_deliveries: ");
        console.log(JSON.parse(JSON.stringify(history_operation_datetime_for_deliveries)));

        this.inventories = this.calc_quantity_by_past_delivery_date(
          this.inventories,
          this.deliveries,
          this.dateFrom,
          history_operation_datetime_for_deliveries,
          this.calc_errors
        );
        console.log("[calc_quantity_by_past_delivery_date] this.inventories: ");
        console.log(JSON.parse(JSON.stringify(this.inventories)));

        this.inventories = this.calc_quantity_by_canceled_history(
          this.inventories,
          this.histories_canceled,
          this.purchase_items,
          this.deliveries,
          this.dateFrom
        )
        console.log("[calc_quantity_by_canceled_history] this.inventories: ");
        console.log(JSON.parse(JSON.stringify(this.inventories)));

        if (this.method_type == "fifo") {
          // 詳細データ
          this.createZaicoMoney();
          // 物品集計データ
          if (this.selectedLanguage == "ja") {
            this.zaicoMoneyAggregatedList = this.createAggregatedZaicoMoney(
              this.zaicoMoneyList,
              "仕入単価",
              this.dateFrom + "の数量",
              this.dateFrom + "の在庫金額"
            );
          } else {
            this.zaicoMoneyAggregatedList = this.createAggregatedZaicoMoney(
              this.zaicoMoneyList,
              "Purchase Price",
              "Quantity at " + this.dateFrom,
              "Inventory Money Amount at " + this.dateFrom
            );
          }
          this.zaicoMoneyAggregatedList = this.delete_zaico_money_due_to_errors(this.zaicoMoneyAggregatedList, this.calc_errors)
        } else if (this.method_type == "moving_average") {
          this.createZaicoMoneyMovingAverage(this.histories_minus);
        } else {
          this.createZaicoMoneyUsingLastPrice();
        }

        this.dateOfSummary = this.dateFrom;
        this.totalQuantityDateFrom = this.calcZaicoQuantity(this.zaicoMoneyList);
        this.chartData = this.createChartData(this.zaicoMoneyList, this.dateFrom);

        if (this.method_type == "fifo") {
          this.chartDataByCustomer = this.createChartDataByCustomerUsingFIFO(this.zaicoMoneyByCustomer, this.dateFrom);
        } else {
          this.chartDataByCustomer = { labels: [] };
        }

        console.log("this.calc_errors:");
        console.log(JSON.parse(JSON.stringify(this.calc_errors)));
        if (Object.keys(this.calc_errors).length > 0) {
          this.hasNoPriceData = true;
        }

        this.isCompletedCreateZaicoMoneyList = true;
        this.isLoading = false;
      }
      return isCompletedFetchAll;
    },
    maxPreviewRows: function () {
      if (this.method_type == "moving_average" && !this.is_advanced_plan) {
        return 5;
      } else {
        return 1000;
      }
    },
  },
  watch: {
    method_type: function () {
      this.initialize();
    },
  },
  methods: {
    ...useCommonMethods(),
    /**
     * 最終仕入原価法で在庫金額データを作成する
     * @type {function}
     */
    async createZaicoMoneyUsingLastPrice() {
      console.log("");
      console.log(JSON.parse(JSON.stringify(this.purchase_items)));

      const purchasesItemsFilterd = this.filterPurchasesItems(this.purchase_items, "2000-01-01", this.dateFrom);
      console.log("purchasesItemsFilterd: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsFilterd)));

      const purchasesItemsSorted = this.sortPurchasesItems(purchasesItemsFilterd);
      console.log("purchasesItemsSorted: ");
      console.log(purchasesItemsSorted);

      console.log("[createZaicoMoneyUsingLastPrice] this.inventories: ");
      console.log(JSON.parse(JSON.stringify(this.inventories)));

      console.log("this.dateFrom: ");
      console.log(this.dateFrom);

      let inventory_unit_price_json = {};
      if (this.is_use_inventory_unit_price) {
        inventory_unit_price_json = this.create_inventory_unit_price_json(this.inventories);
        console.log("inventory_unit_price_json: ");
        console.log(inventory_unit_price_json);
      }

      let zaicoMoneyJson = this.createZaicoMoneyJsonUsingLastPrice(
        this.inventories,
        purchasesItemsSorted,
        this.dateFrom,
        inventory_unit_price_json
      );
      console.log("zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));

      zaicoMoneyJson = this.aggregateSameUnitPrice(zaicoMoneyJson);
      console.log("zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));

      this.zaicoMoneyJson = this.calcZaicoMoney(zaicoMoneyJson);
      console.log("zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyJson)));

      this.zaicoMoneyList = this.convertJsonToList(zaicoMoneyJson);
      console.log("zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList = this.sort(this.zaicoMoneyList);
      console.log("zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList = this.delete_zaico_money_due_to_errors(this.zaicoMoneyList, this.calc_errors)
      console.log("zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList.forEach((zaicoMoney) => {
        if (zaicoMoney[this.dateFrom + "の在庫金額"]) {
          this.totalAmountDateFrom += zaicoMoney[this.dateFrom + "の在庫金額"];
        }
      });

      const { columns, column_names } = this.getColumns(this.zaicoMoneyList);
      this.columns = columns;
      this.column_names = column_names;
    },
    /**
     * 先入先出法で在庫金額データを作成する
     * @type {function}
     */
    async createZaicoMoney() {
      let purchasesItemsAndHistories
      if (this.is_only_purchase_and_packing_slip) {
        purchasesItemsAndHistories = this.purchase_items;
      } else {
        purchasesItemsAndHistories = this.mergePurchasesItemsAndHistories(this.purchase_items, this.histories_plus);
      }
      console.log("purchasesItemsAndHistories: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsAndHistories)));

      const purchasesItemsFilterd = this.filterPurchasesItems(purchasesItemsAndHistories, "2000-01-01", this.dateFrom);
      console.log("purchasesItemsFilterd: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsFilterd)));

      const purchasesItemsSorted = this.sortPurchasesItems(purchasesItemsFilterd);
      console.log("purchasesItemsSorted: ");
      console.log(purchasesItemsSorted);

      let inventory_unit_price_json = {};
      if (this.is_use_inventory_unit_price) {
        inventory_unit_price_json = this.create_inventory_unit_price_json(this.inventories);
        console.log("inventory_unit_price_json: ");
        console.log(inventory_unit_price_json);
      }

      let zaicoMoneyJson = this.createZaicoMoneyJson(
        this.inventories,
        this.purchases,
        purchasesItemsSorted,
        this.dateFrom,
        this.is_only_purchase_and_packing_slip,
        inventory_unit_price_json
      );
      console.log("zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));

      this.zaicoMoneyByCustomer = this.aggregateZaicoMoneyByCustomer(zaicoMoneyJson);
      console.log("zaicoMoneyByCustomer: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyByCustomer)));

      zaicoMoneyJson = this.aggregateSameUnitPrice(zaicoMoneyJson);
      console.log("zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));

      this.zaicoMoneyJson = this.calcZaicoMoney(zaicoMoneyJson);
      console.log("this.zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyJson)));

      this.zaicoMoneyList = this.convertJsonToList(zaicoMoneyJson);
      console.log("this.zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList = this.sort(this.zaicoMoneyList);
      console.log("this.zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList = this.delete_zaico_money_due_to_errors(this.zaicoMoneyList, this.calc_errors)
      console.log("zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList.forEach((zaicoMoney) => {
        if (zaicoMoney[this.dateFrom + "の在庫金額"]) {
          this.totalAmountDateFrom += zaicoMoney[this.dateFrom + "の在庫金額"];
        }
      });

      const { columns, column_names } = this.getColumns(this.zaicoMoneyList);
      this.columns = columns;
      this.column_names = column_names;
    },

    /**
     * 移動平均法で在庫金額データを作成する
     * @type {function}
     */
    async createZaicoMoneyMovingAverage(histories_minus) {
      let purchasesItemsAndHistories
      if (this.is_only_purchase_and_packing_slip) {
        purchasesItemsAndHistories = this.purchase_items;
      } else {
        purchasesItemsAndHistories = this.mergePurchasesItemsAndHistories(this.purchase_items, this.histories_plus);
      }
      console.log("purchasesItemsAndHistories: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsAndHistories)));

      const purchasesItemsFilterd = this.filterPurchasesItems(purchasesItemsAndHistories, "2000-01-01", this.dateFrom);
      console.log("purchasesItemsFilterd: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsFilterd)));

      let deliveriesAndHistories
      if (this.is_only_purchase_and_packing_slip) {
        deliveriesAndHistories = this.deliveries;
      } else {
        deliveriesAndHistories = this.mergeDeliveriesAndHistories(this.deliveries, histories_minus);
      }
      console.log("deliveriesAndHistories: ");
      console.log(JSON.parse(JSON.stringify(deliveriesAndHistories)));

      const deliveriesFilterd = this.filterDeliveries(deliveriesAndHistories, "2000-01-01", this.dateFrom);
      console.log("deliveriesFilterd: ");
      console.log(JSON.parse(JSON.stringify(deliveriesFilterd)));

      const purchasesItemsAndDeliveries = this.mergePurchasesItemsAndDeliveries(
        purchasesItemsFilterd,
        deliveriesFilterd
      );
      console.log("purchasesItemsAndDeliveries: ");
      console.log(JSON.parse(JSON.stringify(purchasesItemsAndDeliveries)));

      const purchasesItemsAndDeliveriesSorted = this.sortPurchasesItemsAndDeliveriesSorted(purchasesItemsAndDeliveries, this.sort_type);
      console.log("purchasesItemsAndDeliveriesSorted: ");
      console.log(purchasesItemsAndDeliveriesSorted);

      let inventory_unit_price_json = {};
      if (this.is_use_inventory_unit_price) {
        inventory_unit_price_json = this.create_inventory_unit_price_json(this.inventories);
        console.log("inventory_unit_price_json: ");
        console.log(inventory_unit_price_json);
      }

      let zaicoMoneyJson = this.createZaicoMoneyJsonMovingAverage(
        this.inventories,
        purchasesItemsAndDeliveriesSorted,
        this.dateFrom,
        inventory_unit_price_json
      );
      console.log("zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(zaicoMoneyJson)));

      this.zaicoMoneyJson = this.calcZaicoMoney(zaicoMoneyJson);
      console.log("this.zaicoMoneyJson: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyJson)));

      this.zaicoMoneyList = this.convertJsonToList(zaicoMoneyJson);
      console.log("this.zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList = this.sort(this.zaicoMoneyList);
      console.log("this.zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList = this.delete_zaico_money_due_to_errors(this.zaicoMoneyList, this.calc_errors)
      console.log("zaicoMoneyList: ");
      console.log(JSON.parse(JSON.stringify(this.zaicoMoneyList)));

      this.zaicoMoneyList.forEach((zaicoMoney) => {
        if (zaicoMoney[this.dateFrom + "の在庫金額"]) {
          this.totalAmountDateFrom += zaicoMoney[this.dateFrom + "の在庫金額"];
        }
      });

      const { columns, column_names } = this.getColumns(this.zaicoMoneyList);
      this.columns = columns;
      this.column_names = column_names;
    },

    /**
     * 最終仕入原価法でdateFrom日時点の在庫金額のjsonを作成する。
     */
    createZaicoMoneyJsonUsingLastPrice(
      inventories,
      purchasesItemsSorted,
      dateFrom,
      inventory_unit_price_json
    ) {
      console.log("start createZaicoMoneyJson");
      let zaicoMoneyJson = {};
      inventories.forEach((inventory) => {
        zaicoMoneyJson[inventory["id"]] = [];

        let zaico_money = JSON.parse(JSON.stringify(inventory));
        zaico_money[dateFrom + "の数量"] = Number(zaico_money.quantity);
        delete zaico_money["quantity"];

        // 仕入明細データが存在しない在庫
        if (!purchasesItemsSorted[inventory["id"]]) {
          zaico_money["仕入単価"] = inventory_unit_price_json[inventory["id"]] || null;
          zaico_money["仕入日"] = "";
          delete zaico_money["quantity"];
          zaicoMoneyJson[zaico_money["id"]].push(zaico_money);
          this.hasNoPriceData = true;
        } else {
          // 仕入明細データが存在する在庫
          const purchase_item = purchasesItemsSorted[inventory["id"]][0];
          if (purchase_item) {
            zaico_money["仕入単価"] = purchase_item["unit_price"] || inventory_unit_price_json[inventory["id"]] || null;
            zaico_money["仕入日"] = purchase_item["purchase_date"];
            zaicoMoneyJson[zaico_money["id"]].push(zaico_money);
          } else {
            zaico_money["仕入単価"] = inventory_unit_price_json[inventory["id"]] || null;
            zaico_money["仕入日"] = "";
            zaicoMoneyJson[zaico_money["id"]].push(zaico_money);
          }
        }
      });
      console.log("end createZaicoMoneyJson");
      return zaicoMoneyJson;
    },

    /**
     * 同じ単価のデータを１つにまとめる
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     * @return {json} - zaicoMoneyJson 在庫金額一覧Json
     */
    aggregateSameUnitPrice(zaicoMoneyJson) {
      console.log("start aggregateSameUnitPrice");
      for (let zaicoId in zaicoMoneyJson) {
        // 比較しやすいように仕入単価でソート
        zaicoMoneyJson[zaicoId] = zaicoMoneyJson[zaicoId].sort(function (a, b) {
          if (a["仕入単価"] !== b["仕入単価"]) {
            return a["仕入単価"] - b["仕入単価"];
          }
          return 0;
        });

        let previousZaicoMoney = {};
        for (var i = 0; i < zaicoMoneyJson[zaicoId].length; i++) {
          let zaicoMoney = zaicoMoneyJson[zaicoId][i];
          // 計算しやすいようにnullを0に置き換える
          zaicoMoney[this.dateFrom + "の数量"] = zaicoMoney[this.dateFrom + "の数量"]
            ? zaicoMoney[this.dateFrom + "の数量"]
            : 0;

          if (zaicoMoney["仕入単価"] != previousZaicoMoney["仕入単価"]) {
            previousZaicoMoney = JSON.parse(JSON.stringify(zaicoMoney));
            continue;
          }
          if (i == 0) {
            previousZaicoMoney = JSON.parse(JSON.stringify(zaicoMoney));
            continue;
          }

          // 仕入単価が同じデータは１つにまとめる
          zaicoMoney[this.dateFrom + "の数量"] += previousZaicoMoney[this.dateFrom + "の数量"];
          if (zaicoMoney["仕入日"] == previousZaicoMoney["仕入日"]) {
            zaicoMoney["仕入日"] = previousZaicoMoney["仕入日"];
          } else {
            zaicoMoney["仕入日"] += "、" + previousZaicoMoney["仕入日"];
          }
          previousZaicoMoney = JSON.parse(JSON.stringify(zaicoMoney));
          if (i > 0) delete zaicoMoneyJson[zaicoId][i - 1];
        }
      }
      console.log("end aggregateSameUnitPrice");
      return zaicoMoneyJson;
    },

    /**
     * 取引先毎の合計在庫金額を計算する。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     * @return {json} - zaicoMoneyByCustomer 取引先毎の合計在庫金額一覧Json
     */
    aggregateZaicoMoneyByCustomer(zaicoMoneyJson) {
      console.log("start aggregateZaicoMoneyByCustomer");
      const zaicoMoneyByCustomer = {};
      for (let zaicoId in zaicoMoneyJson) {
        zaicoMoneyJson[zaicoId].forEach((zaicoMoney) => {
          if (!zaicoMoneyByCustomer[zaicoMoney["取引先"]]) {
            zaicoMoneyByCustomer[zaicoMoney["取引先"]] = 0;
          }
          if (zaicoMoney["仕入単価"] && zaicoMoney[this.dateFrom + "の数量"]) {
            zaicoMoneyByCustomer[zaicoMoney["取引先"]] += zaicoMoney["仕入単価"] * zaicoMoney[this.dateFrom + "の数量"];
          }
        })
      }
      console.log("end aggregateZaicoMoneyByCustomer");
      return zaicoMoneyByCustomer;
    },

    /**
     * 在庫金額を計算する。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     * @return {json} - zaicoMoneyJson 在庫金額一覧Json
     */
    calcZaicoMoney(zaicoMoneyJson) {
      console.log("start calcZaicoMoney");
      for (let zaicoId in zaicoMoneyJson) {
        zaicoMoneyJson[zaicoId].forEach((zaicoMoney) => {
          if (!zaicoMoney["仕入単価"]) return;
          zaicoMoney[this.dateFrom + "の在庫金額"] = zaicoMoney["仕入単価"] * zaicoMoney[this.dateFrom + "の数量"];
          // 小数点第4位まで表示
          zaicoMoney[this.dateFrom + "の在庫金額"] = Math.round(zaicoMoney[this.dateFrom + "の在庫金額"] * 10000) / 10000;
        });
      }
      console.log("end calcZaicoMoney");
      return zaicoMoneyJson;
    },

    calcZaicoQuantity(zaicoMoneyList) {
      return zaicoMoneyList.reduce((sum, item) => sum + item[this.dateFrom + "の数量"] * 10000, 0) / 10000;
    },

    /**
     * jsonの在庫金額一覧をlist形式に変換する。
     * @type {function}
     * @param {json} zaicoMoneyJson - 在庫金額一覧Json
     * @return {array} - zaicoMoneyList 在庫金額一覧
     */
    convertJsonToList(zaicoMoneyJson) {
      console.log("start convertJsonToList");
      let zaicoMoneyList = [];
      for (let zaicoId in zaicoMoneyJson) {
        zaicoMoneyJson[zaicoId].forEach((zaicoMoney) => {
          let newZaicoMoney = JSON.parse(JSON.stringify(zaicoMoney));

          // カラム順を変更する
          var pairs = Object.entries(newZaicoMoney);
          if (this.selectedLanguage == "ja") {
            pairs.splice(2, 0, ["物品名", newZaicoMoney["title"]]);
            if (this.method_type == "moving_average") {
              pairs.splice(3, 0, ["平均取得単価", newZaicoMoney["仕入単価"]]);
              pairs.splice(4, 0, [this.dateFrom + "の数量", newZaicoMoney[this.dateFrom + "の数量"]]);
              pairs.splice(5, 0, [this.dateFrom + "の在庫金額", newZaicoMoney[this.dateFrom + "の在庫金額"]]);
            } else {
              pairs.splice(3, 0, ["仕入単価", newZaicoMoney["仕入単価"]]);
              pairs.splice(4, 0, ["仕入日", newZaicoMoney["仕入日"]]);
              pairs.splice(5, 0, [this.dateFrom + "の数量", newZaicoMoney[this.dateFrom + "の数量"]]);
              pairs.splice(6, 0, [this.dateFrom + "の在庫金額", newZaicoMoney[this.dateFrom + "の在庫金額"]]);
            }
          } else {
            pairs.splice(2, 0, ["Title", newZaicoMoney["title"]]);
            pairs.splice(3, 0, ["Purchase Price", newZaicoMoney["仕入単価"]]);
            pairs.splice(4, 0, ["Purchase Day", newZaicoMoney["仕入日"]]);
            pairs.splice(5, 0, ["Quantity at " + this.dateFrom, newZaicoMoney[this.dateFrom + "の数量"]]);
            pairs.splice(6, 0, [
              "Inventory Money Amount at " + this.dateFrom,
              newZaicoMoney[this.dateFrom + "の在庫金額"],
            ]);
          }
          newZaicoMoney = Object.fromEntries(pairs);
          delete newZaicoMoney["title"];
          delete newZaicoMoney["updated_at"];
          delete newZaicoMoney["created_at"];
          delete newZaicoMoney["operation_datetime"];
          delete newZaicoMoney["item_image"];
          delete newZaicoMoney["quantity_management_attributes"];
          delete newZaicoMoney["stocktake_attributes"];
          delete newZaicoMoney["取引先"];
          delete newZaicoMoney["_purchase_id"];

          zaicoMoneyList.push(newZaicoMoney);
        });
      }
      console.log("end convertJsonToList");
      return zaicoMoneyList;
    },

    // 集計データを作成する
    createAggregatedZaicoMoney(zaicoMoneyJson, aggregateKey, quantityField, zaicoMoneyField) {
      console.log("start createAggregatedZaicoMoney");
      const resultMap = new Map();

      zaicoMoneyJson.forEach((item) => {
        const quantityValue = (item[quantityField] || 0);
        const zaicoMoneyValue = (item[zaicoMoneyField] || 0);

        if (!resultMap.has(item.id)) {
          const newItem = { ...item };
          newItem[quantityField] = quantityValue;
          newItem[zaicoMoneyField] = zaicoMoneyValue;
          newItem[aggregateKey] = item[aggregateKey] !== null ? [item[aggregateKey]] : [];
          resultMap.set(item.id, newItem);
        } else {
          const existingItem = resultMap.get(item.id);
          existingItem[quantityField] = (existingItem[quantityField] || 0) + quantityValue;
          existingItem[zaicoMoneyField] = (existingItem[zaicoMoneyField] || 0) + zaicoMoneyValue;

          if (item[aggregateKey] !== null) {
            existingItem[aggregateKey].push(item[aggregateKey]);
          }

          Object.keys(item).forEach((key) => {
            if (key !== quantityField && key !== zaicoMoneyField && key !== "id" && key !== aggregateKey) {
              if (existingItem[key] !== item[key]) {
                if (typeof existingItem[key] === "string" && !existingItem[key].includes(item[key])) {
                  existingItem[key] += `、${item[key]}`;
                } else if (existingItem[key] !== item[key]) {
                  existingItem[key] = `${existingItem[key]}、${item[key]}`;
                }
              }
            }
          });
        }
      });

      const resultArray = Array.from(resultMap.values()).map((item) => {
        item[aggregateKey] = item[aggregateKey].length > 0 ? item[aggregateKey].join("、") : null;
        return item;
      });

      console.log(resultArray);
      console.log("end createAggregatedZaicoMoney");
      return resultArray;
    },

    rowStyleClassFn(row) {
      return ((row[this.dateFrom + "の数量"] > 0 && !row["仕入単価"]) || this.calc_errors[row["id"]]) ? "red" : "";
    },
    today() {
      var today = new Date();
      today.setDate(today.getDate());
      var yyyy = today.getFullYear();
      var mm = ("0" + (today.getMonth() + 1)).slice(-2);
      var dd = ("0" + today.getDate()).slice(-2);
      return yyyy + "-" + mm + "-" + dd;
    },
    /**
     * 先月の月末
     */
    endOfLastMonth() {
      const today = new Date();
      const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      const yyyy = endOfLastMonth.getFullYear();
      const mm = ("0" + (endOfLastMonth.getMonth() + 1)).slice(-2);
      const dd = ("0" + endOfLastMonth.getDate()).slice(-2);
      return yyyy + "-" + mm + "-" + dd;
    },
    /**
     * データ取得開始
     */
    aggregateBtnClicked() {
      this.initialize();
      this.isLoading = true;
      localStorage.setItem("method_type", this.method_type);
      localStorage.setItem("is_only_purchase_and_packing_slip", this.is_only_purchase_and_packing_slip);
      localStorage.setItem("is_use_inventory_unit_price", this.is_use_inventory_unit_price);
      localStorage.setItem("sort_type", this.sort_type);
      this.mainLoopFetchPastInventories();
      this.mainLoopFetchCurrentInventories();
      this.mainLoopFetchPurchases();
      this.mainLoopFetchPurchasesItems();
      this.mainLoopFetchDeliveries();
      this.mainLoopFetchAllHistories();
    },
    /**
     * dateFromの在庫一覧
     */
    async mainLoopFetchPastInventories() {
      this.isCompletedPastFetchPastInventories = false;
      this.inventories = await this.loopFetchInventories(this.dateFrom);
      this.isCompletedFetchPastInventories = true;
    },
    /**
     * 現在の在庫一覧
     */
    async mainLoopFetchCurrentInventories() {
      this.isCompletedFetchCurrentInventories = false;
      this.current_inventories = await this.loopFetchInventories(this.today());
      this.isCompletedFetchCurrentInventories = true;
    },
    /**
     * 変更履歴一覧
     */
    async mainLoopFetchAllHistories() {
      this.isCompletedFetchAllHistories = false;
      try {
        this.all_histories = await this.loopFetchHistories("2000-01-01", this.nextday(new Date()), "changed");
        console.log("all_histories: ");
        console.log(JSON.parse(JSON.stringify(this.all_histories)));

        this.histories_plus = this.fillter_histories_plus(this.all_histories);
        console.log("this.histories_plus: ");
        console.log(JSON.parse(JSON.stringify(this.histories_plus)));

        if (this.method_type == "moving_average") {
          this.histories_minus = this.fillter_histories_minus(this.all_histories);
          console.log("this.histories_minus: ");
          console.log(JSON.parse(JSON.stringify(this.histories_minus)));
        }

        this.histories_canceled = this.fillter_histories_canceled(this.all_histories, new Date(this.dateFrom));
        console.log("this.histories_canceled: ");
        console.log(JSON.parse(JSON.stringify(this.histories_canceled)));

        this.isCompletedFetchAllHistories = true;
      } catch (e) {
        console.error(e);
        this.showError("変更履歴の集計中にエラーが発生しました: " + (e && e.message ? e.message : e));
      }
    },
    /**
     * 仕入一覧
     */
    async mainLoopFetchPurchases() {
      this.isCompletedFetchPurchases = false;
      this.purchases = await this.loopFetchPurchases();
      console.log("this.purchases: ");
      console.log(JSON.parse(JSON.stringify(this.purchases)));
      this.isCompletedFetchPurchases = true;
    },
    /**
     * 仕入明細一覧
     */
    async mainLoopFetchPurchasesItems() {
      this.isCompletedFetchPurchasesItems = false;
      this.purchase_items = await this.loopFetchPurchasesItems();
      console.log("this.purchase_items: ");
      console.log(JSON.parse(JSON.stringify(this.purchase_items)));
      this.isCompletedFetchPurchasesItems = true;
    },
    /**
     * 出庫明細一覧
     */
    async mainLoopFetchDeliveries() {
      this.isCompletedFetchDeliveries = false;
      this.deliveries = await this.loopFetchDeliveries();
      console.log("this.deliveries: ");
      console.log(JSON.parse(JSON.stringify(this.deliveries)));
      this.isCompletedFetchDeliveries = true;
    },
    /**
     * キャンセル
     */
    cancel() {
      this.isLoading = false;
      this.initialize();
    },
    /**
     * 初期化
     */
    initialize() {
      this.zaicoMoneyList = [];
      this.zaicoMoneyAggregatedList = [];
      this.zaicoMoneyByCustomer = {};
      this.inventories = [];
      this.current_inventories = [];
      this.all_histories = [];
      this.histories_plus = [];
      this.histories_minus = [];
      this.histories_canceled = {};
      this.purchases = {};
      this.purchase_items = {};
      this.deliveries = {};
      this.isCompletedFetchPastInventories = false;
      this.isCompletedFetchCurrentInventories = false;
      this.isCompletedFetchAllHistories = false;
      this.isCompletedFetchPurchasesItems = false;
      this.isCompletedFetchDeliveries = false;
      this.isCompletedCreateZaicoMoneyList = false;
      this.isLoading = false;
      this.isShowError = false;
      this.isShowPreview = false;
      this.isShowAggregatedPreview = false;
      this.errorMsg = "";
      this.columns = [];
      this.column_names = [];
      this.progress = 0;
      this.progressPercentStr = "";
      this.hasNoPriceData = false;
      this.totalAmountDateFrom = 0;
      this.totalQuantityDateFrom = 0;
      this.aggregatedTotalAmountDateFrom = 0;
      this.calc_errors = {};
    },

    /**
     * プレビューを開く
     */
    openPreview() {
      this.$gtag.event("プレビューを開く", { user_id: this.userId });
      this.isShowPreview = true;
    },

    /**
     * 物品集計データのプレビューを開く
     */
    openAggregatedPreview() {
      this.$gtag.event("物品集計データのプレビューを開く", { user_id: this.userId });
      this.isShowAggregatedPreview = true;
    },

    /**
     * プレビューを閉じる
     */
    closePreview() {
      this.$gtag.event("プレビューを閉じる", { user_id: this.userId });
      this.isShowPreview = false;
    },

    /**
     * 物品集計データのプレビューを閉じる
     */
    closeAggregatedPreview() {
      this.$gtag.event("物品集計データのプレビューを閉じる", { user_id: this.userId });
      this.isShowAggregatedPreview = false;
    },

    /**
     * エラー処理
     */
    showError(message) {
      this.$gtag.event("showError", { user_id: this.userId, errMsg: message });

      if (message == "Could not access API. This token is expired.") {
        alert(message);
        window.location.reload();
        return;
      }
      this.isLoading = false;
      this.isShowError = true;
      this.errorMsg = message;
    },
  },
};
</script>

<style>
.home {
  margin: 1.5rem 1.5rem 1.5rem 1.5rem;
}

.content {
  margin-left: 1rem;
}

.btn-info {
  color: #fff;
}

.btn-info:hover {
  color: #fff;
}

.language {
  float: right;
}

.green {
  background: green !important;
}

.red {
  background: rgb(253, 203, 203);
}

th {
  white-space: nowrap;
}

td {
  white-space: nowrap;
}

.button-container {
  display: flex;
  gap: 10px; /* Adjust the gap as needed */
}

.summary-table {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}

.summary-table td {
  border: 5px solid white;
  padding: 10px 0px 10px 0px;
  background-color: lavender;
}

.summary-table .value {
  font-size: 40px;
}
</style>
